import {useState} from 'react';
import {Colors} from 'templates/reports/Section/ScanImages/useColors';
import {ImageType} from 'templates/reports/Section/ScanImages/useImages/query';

const TypeComposite = 'Composite';
export type ImageSelect = ImageType | (typeof TypeComposite);

export type Select = {
	active: ImageSelect
	options: {key: ImageSelect, title: string}[]
	select: (v: ImageSelect) => void
	composite: boolean
}

export const useSelect = (colors: Colors): Select => {
	const [active, select] = useState<ImageSelect>(TypeComposite);

	// Calculate our options by iterating over config/color types
	const options: Select['options'] = [
		{key: TypeComposite, title: TypeComposite},
		...colors.types
			.map((t) => ({
				t,
				c: colors.config(t),
			}))
			.map(({t, c}) => ({
				key: t,
				title: c?.title || t,
			})),
	];

	return {
		active,
		options,
		select,
		composite: active === TypeComposite,
	};
};
